import { CoreModule } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { NgModule } from '@angular/core';
import { NgbCollapseModule, NgbDatepickerModule, NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { PageModule } from '@abp/ng.components/page';
import { AssetComponentComponent } from './components/asset-component.component';
import { AssetComponentRoutingModule } from './asset-component-routing.module';

@NgModule({
  declarations: [AssetComponentComponent],
  imports: [
    AssetComponentRoutingModule,
    CoreModule,
    ThemeSharedModule,
    CommercialUiModule,
    NgxValidateCoreModule,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    PageModule
  ],
})
export class AssetComponentModule {}

export function loadAssetComponentModuleAsChild() {
  return Promise.resolve(AssetComponentModule);
}
